module.exports = __webpack_public_path__ + "img/na.5843af8f.png";